import React, { useState} from 'react'
import EquipmentTypeForm from "../equipment-type-form/EquipmentTypeForm"
import EquipmentService from '../../../../../services/api/equipment.service'
import APIResponse from '../../../../templates/components/APIResponse'

const AddEquipmentType = (props) => {
    const {inputChange} = props;
    const [formData, setFormData] = useState(props.initialData||{})
    const [messages, setMessages] = useState({})
    const [isLoader, setIsLoader] = useState(false)
    const [apiResponse,setApiResponse] = useState()

    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.onClose) {
            props.onClose()
        }
    }

    const submitHandler = (data) => {
        setIsLoader(true)
        EquipmentService.addEquipmentType(data)
            .then(response => {
                setApiResponse(response)
            })
            .catch(error => {
                setApiResponse(error)
            })
            .finally(() => {
                setIsLoader(false)
            });
    }

    const clearForm = () => {
        setFormData({})
    }
    return (
        <div>
            <EquipmentTypeForm submitHandler={submitHandler} initialData={formData} inputChange={inputChange} loaded={!isLoader} onClose={props.onClose} submitLabel="Add" messages={messages} />
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true}/>
        </div>
    )
}

export default AddEquipmentType